import { Component, inject } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import { Subject, finalize, from, switchMap } from 'rxjs';
import { AuthService } from '../../../../services/auth.service';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import {LocationService} from '../../../../services/location.service';


@Component({
    selector: 'tgrid-login-form',
    imports: [MatCardModule, MatInputModule, MatButtonModule, MatProgressSpinnerModule, CommonModule, ReactiveFormsModule, RouterLink],
    templateUrl: './login-form.component.html',
    styleUrl: './login-form.component.scss',
})
export class LoginFormComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private locationService = inject(LocationService);

  public errorMessage = new Subject<string>();

  public loginGroup: FormGroup;
  public isLoading = false;

  constructor() {
    this.loginGroup = new FormGroup({
      username: new FormControl('', {validators: Validators.required}),
      password: new FormControl('', {validators: Validators.required}),
    });
  }


  public login(): void {
    if (this.loginGroup.invalid || this.isLoading) {
      return;
    }

    this.isLoading = true;
    const values = this.loginGroup.getRawValue();
    this.authService.login(values.username, values.password).pipe(
      switchMap(() => from(this.router.navigate(['/app']))),
      finalize(() => {
        this.isLoading = false;
      }),
    ).subscribe({
      next: (success) => {
        if (!success) {
          console.error('Navigation to /app failed');
          this.errorMessage.next('Failed to navigate after login. Please try again.');
        }
      },
      error: (error: Error) => {
        console.error(error);
        this.errorMessage.next('Unable to Login!');
      },
    });
  }
}
